import { Box, Grid, Typography } from "@mui/material";

export default function PrivacyFirst({ lessThanXL }) {
  return (
    <Box
      mt={12}
      sx={{
        color: "#1F1F1F",
        paddingLeft: !lessThanXL ? "70px" : "21px",
        paddingRight: !lessThanXL ? "70px" : "21px",
      }}
    >
      <Typography
        fontWeight="700"
        component="span"
        sx={{
          paddingRight: "5px",
          fontSize: !lessThanXL ? "34px" : "32px",
          fontStyle: !lessThanXL ? "italic" : "",
          background: (theme) => theme.palette.gradient.toTop,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          lineHeight: "normal",
        }}
      >
        Privacy-First
      </Typography>{" "}
      <Typography
        lineHeight={"normal"}
        component="span"
        fontWeight="700"
        sx={{ fontSize: !lessThanXL ? "34px" : "32px" }}
        gutterBottom
      >
        by Design
      </Typography>
      <Typography
        mt={5}
        lineHeight={"normal"}
        variant="body1"
        fontSize="18px"
        fontWeight={400}
        mb={6}
      >
        At Dokusense, we believe powerful AI must never come at the cost of
        privacy. That’s why our platform is built to be compliant, secure, and
        in your control:
      </Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <Typography
            lineHeight={"normal"}
            variant="body2"
            fontSize="18px"
            fontWeight={400}
          >
            <b>Automatic anonymization</b> of sensitive <br />
            fields before any processing
          </Typography>
        </Grid>

        <Grid item xs={12} md={4}>
          <Typography
            lineHeight={"normal"}
            variant="body2"
            fontSize="18px"
            fontWeight={400}
          >
            <b>No storage of personal data by default</b> - your data stays
            yours
          </Typography>
        </Grid>

        <Grid item xs={12} md={4}>
          <Typography
            lineHeight={"normal"}
            variant="body2"
            fontSize="18px"
            fontWeight={400}
          >
            <b>Deploy in your environment</b> <br />- on-premise or in a secure
            private cloud
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
